var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.35,
    height: 46.987,
    viewBox: "0 0 44.35 46.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.951,223.447v14.407a7.061,7.061,0,0,1,4.321-1.468H284.9v-17.26h-9.624A4.326,4.326,0,0,0,270.951,223.447Z",
    transform: "translate(-233.034 -199.013)",
    fill: "#f9a97e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.278,279.407l-.327.79v3.4a9.157,9.157,0,0,1,6.428-2.619h14.37V260.521h-4.1v16.214H275.272A4.309,4.309,0,0,0,271.278,279.407Z",
    transform: "translate(-233.034 -236.608)",
    fill: "#f9a97e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.414,129.232a7.077,7.077,0,0,1,4.807-2.829,5.007,5.007,0,1,0-9.614,0A7.077,7.077,0,0,1,206.414,129.232Z",
    transform: "translate(-169.874 -108.985)",
    fill: "#f9a97e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.025,236.387h9.624a7.06,7.06,0,0,1,4.321,1.468V223.448a4.326,4.326,0,0,0-4.321-4.321H89.025Z",
    transform: "translate(-67.807 -199.014)",
    fill: "#f9a97e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.464,260.521h-4.1v20.455h14.37a9.156,9.156,0,0,1,6.428,2.619v-3.4l-.327-.79a4.31,4.31,0,0,0-3.994-2.672H18.464Z",
    transform: "translate(0 -236.608)",
    fill: "#f9a97e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.406,12.336V17.36h8.378a7.76,7.76,0,1,1,15.286,0h8.378V12.336l-3.294-1.125q-.151-.4-.326-.787L111.362,7.3,106.15,2.087,103.025,3.62q-.388-.175-.787-.326L101.112,0h-7.37L92.617,3.294q-.4.151-.787.326L88.7,2.087,83.493,7.3l1.534,3.125q-.175.388-.326.787Z",
    transform: "translate(-60.887)",
    fill: "#f9a97e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.bce057dc9ee7cbad728719e0290d2328.svg";
export { ForwardRef as ReactComponent };